import { hasItems } from "../utils/collections";
import { AccessPolicy, Permission, UserRole } from "./permissions";

export const hasPermission = (requiredPermission: Permission, availableRoles: UserRole[]): boolean => {
    if (!requiredPermission) {
        // No special permissions needed
        return true;
    }

    const accessPolicy = accessPolicies.find(ap => ap.permission === requiredPermission);
    if (!accessPolicy || !hasItems(accessPolicy.requiredRoles)) {
        // This permission doesn't require an access policy
        return true;
    }

    // At least one of the required role should be available
    return accessPolicy.requiredRoles.some(r => availableRoles.indexOf(r) !== -1);
}

const AnyoneCanDoIt: UserRole[] = []; // empty array means no role checks apply, same as "anyone can do it"
const accessPolicies: AccessPolicy[] = [
    {
        permission: Permission.Ticket_View,
        requiredRoles: AnyoneCanDoIt,
    },
    {
        permission: Permission.Ticket_Edit,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Ticket_Add,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Ticket_FlagForModeration,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Ticket_Vote,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Ticket_ViewInternalTicket,
        requiredRoles: [UserRole.MicrosoftEmployees],
    },
    {
        permission: Permission.Comment_View,
        requiredRoles: AnyoneCanDoIt,
    },
    {
        permission: Permission.Comment_Add,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Comment_Edit,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Comment_Delete,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Comment_FlagForModeration,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Comment_Convert,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Comment_Vote,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Solution_View,
        requiredRoles: AnyoneCanDoIt,
    },
    {
        permission: Permission.Solution_Add,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Solution_Edit,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Solution_Delete,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Solution_FlagForModeration,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Solution_Convert,
        requiredRoles: [UserRole.Moderators, UserRole.Author],
    },
    {
        permission: Permission.Solution_Vote,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Solution_Reactivate,
        requiredRoles: [UserRole.AuthenticatedUsers],
    },
    {
        permission: Permission.Preview2,
        requiredRoles: AnyoneCanDoIt,
    },
]

export default accessPolicies;
